<template>
  <div class="plv-ia-answer-question-edit">
    <div class="plv-ia-answer-question-edit__top">
      <div class="plv-ia-answer-question-edit__section plv-ia-clearfix">
        <div class="plv-ia-answer-question-edit__label">{{ t('plvIA.answerCard.questionType') }}</div>
        <div class="plv-ia-answer-question-edit__content plv-ia-answer-question-edit-quick-type">
          <form-radio v-model="type" name="type" value="R">{{ t('plvIA.answerCard.oneChoiceLabel') }}</form-radio>
          <form-radio v-model="type" name="type" value="C">{{ t('plvIA.answerCard.multipleChoiceLabel') }}</form-radio>
        </div>
      </div>

      <div class="plv-ia-answer-question-edit__section plv-ia-answer-question-edit-wenda">
        <wenda-option
          v-for="(item, index) in options"
          :key="index"
          :options="item.split('')"
          :active="activeOption === item"
          :disabled="item === 'AB' && optionDisabled"
          @click="changeOption"
        />
      </div>
    </div>

    <div class="plv-ia-answer-question-edit__bottom">
      <button class="plv-ia-btn-new plv-ia-btn-blue" @click="send">{{ t('plvIA.answerCard.send') }}</button>
      <duration-setting
        v-if="false"
        :duration.sync="duration"
        :enable-limit-time.sync="enableLimitTime"
      />
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import FormRadio from '@/components/form/Radio';
import Locale from '@/mixins/locale';
import WendaOption from './WendaOption';
import DurationSetting from './DurationSetting';

export default {
  components: {
    FormRadio,
    WendaOption,
    DurationSetting,
  },
  mixins: [Locale],

  props: {
    channelSetting: {
      type: Object,
      default() {
        return {
          defaultLimitTimeAnswer: false, // 是否默认启用定时发送
        };
      }
    },
  },

  data() {
    return {
      type: 'R',
      options: ['AB', 'ABC', 'ABCD', 'ABCDE'],
      activeOption: 'AB',
      optionDisabled: false,
      enableLimitTime: false, // 暂时屏蔽快速问答的限时功能
      // enableLimitTime: this.channelSetting.defaultLimitTimeAnswer,
      duration: 8,
    };
  },

  watch: {
    type(val, oldVal) {
      if (val === oldVal) return;
      this.changeType(val);
    }
  },

  methods: {
    changeType(type) {
      this.type = type;
      this.optionDisabled = type === 'C';
      this.activeOption = type === 'C' ? 'ABC' : 'AB';
    },

    changeOption(option, disabled) {
      if (!disabled) this.activeOption = option;
    },

    send: debounce(function() {
      // utils.logger.info('[click btn][answer card][quick] send');
      const duration = parseInt(this.duration, 10);
      if (this.enableLimitTime && !duration) {
        this.$iaMessage.default(this.t('plvIA.answerCard.enterTimeLimit'));
        return;
      }

      const optionList = this.activeOption.split('');
      const data = {
        type: this.type,
        itemType: 1,
        answer: this.activeOption,
        name: this.t('plvIA.answerCard.quickQuestion'),
      };
      optionList.forEach((item, index) => {
        data[`option${index + 1}`] = item;
      });
      if (this.enableLimitTime) {
        data.duration = this.duration;
      }
      this.$emit('send', data);
    }, 300),
  }
};
</script>

<style lang="scss">
.plv-ia-answer-question-edit-wenda {
  width: (120px + 20px) * 2;
  margin-top: 20px;
}
.plv-ia-answer-question-edit-quick-type {
  .plv-ia-radio {
    margin-right: 22px;
  }
}
</style>
